import React, { useMemo, useState, useEffect } from 'react';
import { Collapse, Icon, Modal, Tooltip } from 'antd';
import {
  Button,
  Table,
  Widget,
  ColumnProps,
  ColumnType,
  MasterDetailForm,
  FormSubmitButton,
  FormatText,
  FormInput,
  FormDatePicker,
} from '@digital/ui';
import * as Yup from 'yup';
import { UploadFile } from '@app/components';
import { hasPermission } from '@app/helpers/permissions';
import { newGuid } from '@app/helpers/geradorGuid';

const { Panel } = Collapse;

interface ModalIncluirAvaliacaoProps {
  incluir(fornecedorId: string, formValues: any): void;
  fornecedorId: string;
  fecharModalSucesso: boolean;
}

const ModalIncluirAvaliacao = ({ incluir, fornecedorId, fecharModalSucesso }: ModalIncluirAvaliacaoProps) => {
  useEffect(() => {}, []);

  const [exibirModal, setExibirModal] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState();
  const [hasFile, setHasFile] = useState<boolean>(true);

  useEffect(() => {
    setInitialValues({ dataValidade: '', comentario: '', arquivo: '', idFake: newGuid() } as any);
    setHasFile(!hasFile);
  }, [exibirModal]);

  const incluirArquivo = (formValues: any) => {
    incluir(fornecedorId, formValues);
  };

  useEffect(() => {
    setExibirModal(false);
  }, [fecharModalSucesso]);

  return (
    <>
      <Button
        onClick={() => {
          setExibirModal(true);
        }}>
        {' '}
        Incluir
      </Button>
      <Modal
        title="Anexos"
        width="1200px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formModal"
          validationSchema={Yup.object().shape({
            dataValidade: Yup.string().required('Data Validade deve ser informada'),
            comentario: Yup.string().required('Comentário deve ser informado'),
          })}
          initialValues={initialValues}
          onSubmit={incluirArquivo}
          actions={[
            <Button
              type="link"
              onClick={() => {
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton noIcon={true} type="primary" disabled={!hasPermission(['SAS_FORNECEDOR_INCLUIR'])}>
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <FormDatePicker format="DD/MM/YYYY" label="Data Validade" name="dataValidade" span={3} />
            <FormInput label="Comentário" name="comentario" span={12} />
            <UploadFile nameFormData={'arquivo'} label={'INSERIR ANEXO'} hasFile={hasFile} />
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};

export default ModalIncluirAvaliacao;
